import Router from '@/router'
import Message from './message.js';
import store from '@/store'
export default (function() {
    var _axios, vue
    var agency_key = "/v2"
    var get_file = "/filePath1"
    var get_url = "https://test.aiosign.com"
    var _serve = {
        manage: agency_key + "/guodun-serve-manage-lzm",
        usermanage: agency_key + "/eseal-usermanage",
        file: agency_key + "/eseal-file",
        auth: agency_key + "/eseal-auth",
        seal: agency_key + "/eseal-seal",
        signature: agency_key + "/eseal-contract-signature",
        elSignature: agency_key + "/eseal-signature",
        meal: agency_key + "/eseal-meal",
        order: agency_key + "/eseal-order",
        pay: agency_key + "/eseal-pay",
        contract: agency_key + "/guodun-contract",
        menhu: agency_key + "/eseal-menhu",
    }

    function gotoLogin() {
        Router.push({
                name: 'login'
            })
            // window.location.replace("/#/login");
    }
    /*
     *  登录
     */
    function login({
        params,
        succFun,
        failFun
    }) {
        params.clientType = "web"
        _axios.post(_serve.usermanage + '/login', params).then(function(response) {
            if (response.status == 200) {
                localStorage.setItem("SET_TOKEN", response.data.token);
                if (typeof succFun === "function") {
                    setLocalStorage('userInfo', response.data.data)
                    succFun(response.data);
                }
            } else {
                if (failFun) {
                    failFun(response.data)
                }
            }
        });
    }
    // 退出登录
    function logOut() {
        _axios.post(_serve.usermanage + '/logout').then(function(response) {
            if (response.status == 200) {
                if (response.data.code == 10000) {
                    localStorage.clear();
                    gotoLogin()
                }
            }
        });
    }
    // 写入缓存
    function setLocalStorage(key, val) {
        val = JSON.stringify(val)
        window.localStorage.setItem(key, val)
    }
    // 读取缓存
    function getLocalStorage(key) {
        return JSON.parse(window.localStorage.getItem(key))
    }
    //  获取用户信息
    function getUserInfo({
        succFun,
        failFun
    }) {
        _axios.post(_serve.usermanage + '/user/query/Info')
            .then(function(response) {
                if (response.status == 200) {
                    if (typeof succFun === "function") {
                        succFun(response.data);
                    }
                } else {
                    failFun(response.data)
                }
            });
    }
    // 上传文件
    function uploadFile({
        params,
        succFun,
        failFun
    }) {
        // var fileToken = res.data.data;
        var data = new FormData();
        if(params.data.file_name){
            data.append("file", params.file, params.data.file_name)
        }else {
            data.append("file", params.file)
        }
        _axios.post( _serve.file+ "/file/upLoad?project=" + params.data.project + "&business=" + params.data.business, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(
                res => {
                    if (res.data.code == 10000) {
                        // res.data.data.downloadUrl = get_file_key + res.data.data.downloadUrl;
                        if (typeof succFun === "function") {
                            succFun(res.data);
                        }
                    }else {
                        if (typeof failFun === "function") {
                            failFun(res.data)
                        }
                    }
                }
            ).then(
                res => {
                    if (typeof failFun === "function") {
                        failFun(res)
                    }
                }
           );
    }
    // 上传印章图片
    function uploadImg({
                            params,
                            succFun,
                            failFun
                        }) {

        var data = new FormData();
        data.append("file", params.file)
        _axios.post(_serve.file + "/file/sealFileUpload?project=" + params.data.project + "&business=" + params.data.business, data,{
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(function(response) {
                if ( response.status == 10000 || response.status == 200) {
                    if(response.data.data != null){
                        // response.data.data.downloadUrl = response.data.data.downloadUrl;
                    }
                    if (typeof succFun === "function") {
                        succFun(response.data);
                    }
                } else {
                    failFun(response.data)

                }


            });
    }
    //   删除文件
    function delFile({
        params,
        succFun,
        failFun
    }) {
        _axios.get(_serve.file + "/file/deleteFileBy?id=" + params.id)
            .then(
                res => {
                    if ((res.data.code == 10000 || res.data.code == 200)) {
                        if (typeof succFun === "function") {
                            succFun(res.data);
                        }
                    } else {

                        if (typeof failFun === "function") {
                            failFun(res.data)
                        }
                    }

                }
            ).then(
                res => {
                    if (typeof failFun === "function") {
                        failFun(res.data)
                    }
                }
            );
    }
    // 文件下载

    function downloadFile({
        params,
        succFun,
        failFun
    }) {
        _axios.post(_serve.file + "/file/getFileName", {
                id: params.id
            })
            .then(
                res => {
                    if (res.data.code == 10000 || res.data.code == 200) {
                        if (typeof succFun === "function") {
                            // res.data.data.url = get_file_key + res.data.data.url;
                            succFun(res.data);
                        }
                    } else {
                        if (typeof failFun === "function") {
                            failFun(res)
                        }
                    }

                }
            ).then(
                res => {
                    if (typeof failFun === "function") {
                        failFun(res)
                    }
                }
            );
    }
    //  批量下载
    function downloadListFile({
        params,
        succFun,
        failFun
    }) {
        _axios.post(_serve.file + "/file/getDownloadUrlsByIds", {
                ids: params.ids
            })
            .then(
                res => {
                    if (res.data.code == 10000 || res.status == 200) {
                        if (typeof succFun === "function") {
                            succFun(res.data);
                        }
                    } else {
                        failFun(res.data)
                    }
                },
                res => {
                    if(res){
                        Message({
                            message: res.data.msg,
                            type: "warning"
                        });
                    }else {
                        Message({message: '请求超时', type: 'error'});
                    }
                }
            );
    }
    //   发送短信
    function sendByPhone({
        params,
        succFun,
        failFun
    }) {
        httpPost({
            url: _serve.usermanage + "/sms/sendByPhone",
            data: {
                appId: "0000000033",
                useWhere: params.useWhere,
                toPhone: params.toPhone
            },
            succFun,
            failFun
        })
    }
    // 发送邮件
    function sendByEmails({
        params,
        succFun,
        failFun
    }) {
        httpPost({
            url: _serve.usermanage + "/email/sendByEmails",
            data: {
                templateId: params.templateId,
                toEmail: params.toEmail
            },
            succFun,
            failFun
        })
    }
    // post请求
    function httpPost({
        url,
        data,
        succFun,
        failFun
    }) {
        _axios.post(url, data || {})
            .then(
                res => {
                    if (res.data.code == 10000 || res.data.code == 200) {
                        if (typeof succFun === "function") {
                            succFun(res.data);
                        }
                    } else {
                        if (typeof failFun === "function") {
                            failFun(res.data)
                        } else {
                            Message({
                                message: res.data.msg,
                                type: "warning"
                            });
                        }
                    }
                },
                res => {
                    if(res){
                        Message({
                            message: res.data.msg,
                            type: "warning"
                        });
                    }else {
                        Message({message: '请求超时', type: 'error'});
                    }

                }
            );
    }

    function httpGet({
        url,
        succFun,
        failFun
    }) {
        _axios.get(url)
            .then(
                res => {
                    if (res.data.code == 10000 || res.data.code == 200) {
                        if (typeof succFun === "function") {
                            succFun(res.data);
                        }
                    } else {
                        if (typeof failFun === "function") {
                            failFun(res.data)
                        } else {
                            Message({
                                message: res.data.msg,
                                type: "warning"
                            });
                        }
                    }
                },
                res => {
                    if(res){
                        Message({
                            message: res.data.msg,
                            type: "warning"
                        });
                    }else {
                        Message({message: '请求超时', type: 'error'});
                    }
                }
            );
    }
    return {
        init: function(Vue) {
            vue = Vue;
            _axios = Vue.axios;
        },
        httpPost: httpPost,
        httpGet: httpGet,
        getUserInfo: getUserInfo,
        uploadFile: uploadFile,
        uploadImg: uploadImg,
        downloadFile: downloadFile,
        delFile: delFile,
        _serve: _serve,
        get_url: get_url,
        get_file:get_file,
        sendByPhone: sendByPhone,
        downloadListFile: downloadListFile,
        setLocalStorage: setLocalStorage,
        getLocalStorage: getLocalStorage,
        login: login,
        logOut: logOut,
        sendByEmails: sendByEmails,

    }
})();